// styles
import '../../scss/widgets/hotel-slider.scss';


;( function () {
    window.addEventListener("elementor/frontend/init", function () {
        elementorFrontend.hooks.addAction("frontend/element_ready/ikos-hotel-slider.default", function ($scope) {
            boom( $scope[0] )
        })
		elementorFrontend.hooks.addAction("frontend/element_ready/ikos-carousel-slider.default", function ($scope) {
            boom( $scope[0] )
        })
    })
}) ()

function boom( element ) {
    if ( ! element ) return;

    initSlider( element.querySelector('.ikos-resorts-slider') )
}

function initSlider( node ) {

    if ( ! window.ikosSwiper ) {
        console.warn( 'window.ikosSwiper: dependency not found' );
    }

    const { Swiper, Navigation, Pagination } = window.ikosSwiper

    if ( ! node || typeof node !== 'object' || node.nodeType === undefined ) {
        console.error( `Invalid slider element ${node}` );
    }

    /**
     * Main slider starts here
     */
    function sliderResize( _swiper ) {
        const sizeLg = _swiper.el.clientWidth - 480;
        const size = _swiper.el.clientWidth - 340;
        const sizeMd = _swiper.el.clientWidth - 250;
        const sizeSm = _swiper.el.clientWidth - 120;
        node.style.setProperty('--slide-width-lg', `${sizeLg}px`)
        node.style.setProperty('--slide-width', `${size}px`)
        node.style.setProperty('--slide-width-md', `${sizeMd}px`)
        node.style.setProperty('--slide-width-sm', `${sizeSm}px`)
    }

    const options = {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        init: true,
        speed: 400,
        modules: [ Navigation, Pagination ],
        navigation: {
            nextEl: node.querySelector('.slider-button-next button'),
            prevEl: node.querySelector('.slider-button-prev button'),
        },
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 20,
            },
            1024: {
                spaceBetween: 30,
                slidesPerView: "auto",
            }
        },
        pagination: {
            el: node.querySelector('.slider-pagination'),
            clickable: true
        },
    }

    const events = {
        on: {
            afterInit: function (_swiper) {
                sliderResize(_swiper)
            },
            beforeInit: function (_swiper) {
                sliderResize(_swiper)
            },
            beforeResize: function ( _swiper ) {
                sliderResize(_swiper)
            },
        }
    }

    new Swiper( node, {
        ...options,
        ...events,
    } )

}


